import { render, staticRenderFns } from "./NewLead.vue?vue&type=template&id=ef82f896&scoped=true"
import script from "./NewLead.vue?vue&type=script&lang=js"
export * from "./NewLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef82f896",
  null
  
)

export default component.exports